import { jsx as d } from "react/jsx-runtime";
import * as a from "react";
import { a as E, g as b } from "../../index.esm-B8NUmg-c.js";
import { Typography as j } from "../Typography/index.js";
var F = function(e) {
  var r = e.as, n = e.errors, p = e.name, i = e.message, l = e.render, v = (function(o, h) {
    if (o == null) return {};
    var m, t, f = {}, u = Object.keys(o);
    for (t = 0; t < u.length; t++) h.indexOf(m = u[t]) >= 0 || (f[m] = o[m]);
    return f;
  })(e, ["as", "errors", "name", "message", "render"]), x = E(), s = b(n || x.formState.errors, p);
  if (!s) return null;
  var c = s.message, y = s.types, g = Object.assign({}, v, { children: c || i });
  return a.isValidElement(r) ? a.cloneElement(r, g) : l ? l({ message: c || i, messages: y }) : a.createElement(r || a.Fragment, g);
};
const C = ({
  errors: e,
  name: r
}) => /* @__PURE__ */ d(
  F,
  {
    errors: e,
    name: r,
    render: ({ message: n }) => /* @__PURE__ */ d(
      j,
      {
        variant: "bodyS",
        color: "current",
        className: "text-red-300 pt-2",
        children: n
      }
    )
  }
);
export {
  C as FormErrorMessage
};
